<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button variant="outline" class="w-8 h-8 bg-muted" @click.stop>
        <svg-icon name="huge-more" class="w-5 h-5 text-muted-foreground" />
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent class="menu" :align="align">
      <template v-for="item in actions" :key="item.label">
        <DropdownMenuSeparator v-if="item.isLast" />
        <DropdownMenuItem
          :variant="item.type === 'danger' ? 'destructive' : undefined"
          class="!p-0 !m-0 w-full"
          @click="$emit('action', item)"
        >
          <div class="item">
            <svg-icon
              v-if="item.icon"
              :name="item.icon"
              class="w-4 h-4"
              :class="item.type || ''"
            />
            <span :class="item.type || ''">
              {{ $t(item.label) }}
            </span>
          </div>
        </DropdownMenuItem>
      </template>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script>
import Button from "@/shared/ui/button/Button.vue";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";

export default {
  name: "TableRowActions",
  components: {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  },
  props: {
    actions: {
      type: Array,
      required: true,
    },
    align: {
      type: String,
      default: "start",
    },
  },
  emits: ["action"],
};
</script>

<style scoped lang="scss">
.menu {
  @apply w-64 p-2 bg-card rounded-xl flex flex-col gap-2 outline outline-1 outline-offset-[-1px];
}

.item {
  @apply px-3 py-2 rounded-lg flex items-center gap-3 cursor-pointer transition-colors;

  svg {
    @apply text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }

  span {
    @apply font-medium leading-6 text-foreground;

    &.danger {
      @apply text-red-400;
    }
  }
}
</style>
